import { render, staticRenderFns } from "./ProposalCard.vue?vue&type=template&id=7f903f87&scoped=true&"
import script from "./ProposalCard.vue?vue&type=script&lang=js&"
export * from "./ProposalCard.vue?vue&type=script&lang=js&"
import style0 from "./ProposalCard.vue?vue&type=style&index=0&id=7f903f87&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f903f87",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardText,VImg,VSpacer})
